import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function Section6() {
  return <section className="py-24 px-6 bg-ivory" data-id="element-216">
      <div className="max-w-4xl mx-auto" data-id="element-217">
        <FadeIn data-id="element-218">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-dark mb-12" data-id="element-219">
            RESUMEN DE LA OFERTA
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-220">
          <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden" data-id="element-221">
            <div className="bg-dark text-gold p-6 text-center" data-id="element-222">
              <h3 className="text-2xl font-serif font-bold" data-id="element-223">
                Lo que obtienes hoy
              </h3>
            </div>

            <div className="p-8" data-id="element-224">
              <ul className="space-y-4 mb-8" data-id="element-225">
                {['Manual completo, El archivo PDF', 'Auditoría de crédito paso a paso', 'Leyes federales explicadas en español', 'Cartas de disputa listas para usar', 'Plan de reconstrucción de score', 'Guía de hipoteca para hispanos'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-226">
                    <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-227" />
                    <span className="text-lg text-dark" data-id="element-228">{item}</span>
                  </li>)}
              </ul>

              <div className="bg-ivory-dark p-6 rounded text-center mb-6" data-id="element-229">
                <p className="text-sm text-dark-light uppercase tracking-wider mb-2" data-id="element-230">
                  Valor real de este conocimiento
                </p>
                <p className="text-xl font-bold text-dark line-through opacity-50" data-id="element-231">
                  Lo que un abogado de crédito te cobra en 3 meses
                </p>
              </div>

              <div className="text-center" data-id="element-232">
                <p className="text-sm text-gold-dark uppercase tracking-wider font-bold mb-2" data-id="element-233">
                  Tu inversión hoy
                </p>
                <p className="text-5xl font-bold text-dark mb-2" data-id="element-234">$16 USD</p>
                <p className="text-dark-light" data-id="element-235">
                  Un solo pago. Acceso inmediato.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}